/** Producto para el cual aplican tipo de ingreso y (si free) leads permitidos */
export const PRODUCT_ID_WITH_ENTRY_RULES = '8';

/** Texto en pantalla para el producto id 8 */
export const PRODUCT_8_DISPLAY_NAME = 'Anuncio Simple';

export const PRODUCT_IDS_VALID = ['1', '2', '7', '8', '9'] as const;

export const PRODUCT_OPTIONS = [
    { label: 'Destacado', value: '1' },
    { label: 'Prime', value: '2' },
    { label: 'Smart Leads', value: '7' },
    { label: PRODUCT_8_DISPLAY_NAME, value: '8' },
    { label: 'Elite', value: '9' },
];

export const ENTRY_TYPE_OPTIONS = [
    { label: 'Pago', value: 'pago' },
    { label: 'Free', value: 'free' },
    { label: 'Cooldown', value: 'cooldown' },
];

export const DURATION_PRESET_OPTIONS = [
    { label: '1 mes', value: '1m' },
    { label: '3 meses', value: '3m' },
    { label: '6 meses', value: '6m' },
    { label: 'Otra', value: 'other' },
] as const;

export type DurationPreset = (typeof DURATION_PRESET_OPTIONS)[number]['value'];

export type FormValues = {
    product_id: string;
    email: string;
    entry_type: string;
    allowed_leads: string;
    date_start: Date;
    date_end: Date;
    duration_preset: DurationPreset;
};
